export function WithoutPermission() {
    return (
        <div style={{ alignSelf: "center", justifySelf: "center" }}>
            <h2>Você não tem permissão para acessar essa página!</h2>
        </div>
    );
}